/* tslint:disable */
/* eslint-disable */
/**
 * BS2
 * BoostSales 2
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { CategoryEventProjectionName } from './CategoryEventProjectionName';
import {
    CategoryEventProjectionNameFromJSON,
    CategoryEventProjectionNameFromJSONTyped,
    CategoryEventProjectionNameToJSON,
    CategoryEventProjectionNameToJSONTyped,
} from './CategoryEventProjectionName';

/**
 * 
 * @export
 * @interface EventProjection
 */
export interface EventProjection {
    /**
     * 
     * @type {Array<CategoryEventProjectionName>}
     * @memberof EventProjection
     */
    categIds: Array<CategoryEventProjectionName> | null;
    /**
     * 
     * @type {string}
     * @memberof EventProjection
     */
    start: string;
}

/**
 * Check if a given object implements the EventProjection interface.
 */
export function instanceOfEventProjection(value: object): value is EventProjection {
    if (!('categIds' in value) || value['categIds'] === undefined) return false;
    if (!('start' in value) || value['start'] === undefined) return false;
    return true;
}

export function EventProjectionFromJSON(json: any): EventProjection {
    return EventProjectionFromJSONTyped(json, false);
}

export function EventProjectionFromJSONTyped(json: any, ignoreDiscriminator: boolean): EventProjection {
    if (json == null) {
        return json;
    }
    return {
        
        'categIds': (json['categ_ids'] == null ? null : (json['categ_ids'] as Array<any>).map(CategoryEventProjectionNameFromJSON)),
        'start': json['start'],
    };
}

export function EventProjectionToJSON(json: any): EventProjection {
    return EventProjectionToJSONTyped(json, false);
}

export function EventProjectionToJSONTyped(value?: EventProjection | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'categ_ids': (value['categIds'] == null ? null : (value['categIds'] as Array<any>).map(CategoryEventProjectionNameToJSON)),
        'start': value['start'],
    };
}

